import { Fade } from "@/components/Reveal";

const Kicker = () => (
  <Fade className="mb-10 flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink/45">
    <span className="text-accent-dark">—</span>
    <span className="h-px w-10 bg-ink/20" aria-hidden="true" />
    <span>Legale</span>
  </Fade>
);

const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-display text-xl font-bold tracking-tight">{title}</h2>
    <div className="mt-4 space-y-4 text-sm leading-relaxed text-ink/65 md:text-base">{children}</div>
  </section>
);

const CookiePolicyPage = () => (
  <div data-testid="cookie-policy-page" className="bg-fog pt-[72px] text-ink">
    <div className="mx-auto max-w-3xl px-6 py-20 lg:py-28">
      <Kicker />
      <Fade>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
          Cookie Policy
        </h1>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-ink/40">
          Ultimo aggiornamento: settembre 2026
        </p>

        <Section title="1. Cosa sono i cookie">
          <p>
            I cookie sono piccoli file di testo che i siti web salvano sul dispositivo
            dell'utente durante la navigazione, per finalità tecniche, di analisi o di
            profilazione.
          </p>
        </Section>

        <Section title="2. Cookie utilizzati da questo sito">
          <p>
            Questo sito <strong>non utilizza cookie propri</strong> e non utilizza cookie di
            profilazione, marketing o tracciamento che richiedano il consenso dell'utente.
          </p>
          <p>
            Non sono presenti strumenti di analytics di terze parti installati dal titolare
            (Google Analytics, Meta Pixel o simili non sono attivi).
          </p>
        </Section>

        <Section title="3. Tecnologie tecniche della piattaforma di hosting">
          <p>
            Il sito è ospitato su infrastruttura Emergent, che utilizza tecnologie strettamente
            tecniche (incluse protezioni di sicurezza Cloudflare) necessarie all'erogazione, alla
            sicurezza e alle prestazioni del servizio. Queste tecnologie non richiedono consenso
            ai sensi della normativa vigente.
          </p>
        </Section>

        <Section title="4. Servizi esterni raggiungibili tramite link">
          <p>
            Il sito contiene collegamenti verso servizi esterni — Business Freedom 360, Amazon,
            Instagram, LinkedIn e WhatsApp. Navigando su quei servizi si applicano le rispettive
            cookie policy, disponibili sui relativi siti.
          </p>
        </Section>

        <Section title="5. Come gestire i cookie dal browser">
          <p>
            Puoi in ogni caso gestire o eliminare i cookie attraverso le impostazioni del tuo
            browser. La disattivazione dei cookie tecnici potrebbe influire sul corretto
            funzionamento di alcuni siti web.
          </p>
        </Section>

        <Section title="6. Titolare e contatti">
          <p>
            Titolare: ditta individuale Mattia Cosimo Saracino, P.IVA 02601020742, Mesagne (BR),
            Italia —{" "}
            <a href="mailto:saracinomat98@gmail.com" className="text-accent-dark underline underline-offset-4">
              saracinomat98@gmail.com
            </a>
          </p>
        </Section>
      </Fade>
    </div>
  </div>
);

export default CookiePolicyPage;
